import { DATE_TIME_FORMATS, ISSUE_STATUSES } from "@miplatform/constants";
import {
  formatDate,
  getTimeOfDay,
  getTimeOfDayInterval,
} from "@miplatform/utils";
import { SPECIFIED_TIME } from "../EmailTemplate/emailTemplateConstants";
import { getOneLineAddress, getRecipientName } from "./emailFormUtil";

export const getAppointmentConfirmationSubject = (attempt) => {
  const orderNumber = attempt.assignment?.assignmentNumber || "N/A";

  return `Appointment Confirmed for ${orderNumber} at ${getOneLineAddress(
    attempt.home.address
  )}`;
};

export const getTechnicianEnrouteSubject = (attempt, arrivalWindow) => {
  return `Technician Enroute to ${getOneLineAddress(
    attempt.home.address
  )} - ${getAttemptTimeWindow(attempt, arrivalWindow)}`;
};

export const getOrderAssignmentSubject = (attempt) => {
  const orderNumber = attempt.assignment?.assignmentNumber || "N/A";

  return `You have a new Order Dispatch - ${orderNumber}`;
};

export const getAppointmentConfirmationDetails = (recipients) => {
  const recipientNames = getRecipientName(recipients);

  return `${recipientNames},\n\nYour service request has been scheduled as follows:`;
};

export const getTechnicianEnrouteDetails = (
  recipients,
  attempt,
  arrivalWindow
) => {
  const recipientNames = getRecipientName(recipients);

  return `${recipientNames},\n\nYour service technician${
    attempt.assignedUserName ? `, ${attempt.assignedUserName}` : ""
  } is en route to ${getOneLineAddress(
    attempt.home.address
  )}.\n${getAttemptTimeWindow(attempt, arrivalWindow)}.`;
};

export const getOrderAssignmentDetails = (recipients) => {
  const recipientNames = getRecipientName(recipients);

  return `${recipientNames},\n\nYour order assignment has been scheduled as follows:`;
};

export const getCloseoutAndUpdateSubject = (attempt) => {
  const orderNumber = attempt.assignment?.assignmentNumber || "N/A";

  return `Order Update for ${orderNumber} at ${getOneLineAddress(
    attempt.home.address
  )}`;
};

export const getCloseoutAndUpdateDetails = (recipients, attempt) => {
  const recipientNames = getRecipientName(recipients);

  if (attempt.issues.every((issue) => issue.status === ISSUE_STATUSES.CLOSED)) {
    return `${recipientNames},\n\nAll of the work for your home has been completed. Thank you for your business!`;
  }

  if (
    attempt.issues.every(
      (issue) =>
        issue.status === ISSUE_STATUSES.CANCELLED ||
        issue.status === ISSUE_STATUSES.CLOSED
    )
  ) {
    return `${recipientNames},\n\nYour request has been reviewed by our technician. The repair was noted as incomplete, and no return visit is required at this time.`;
  }

  return `${recipientNames},\n\nYour request was partially completed, and ${
    attempt.assignedUserName
      ? `your service technician ${attempt.assignedUserName}`
      : "the service technician"
  } will return to complete the work at a later date.`;
};

export const getAttemptTimeWindow = (attempt, arrivalWindow) => {
  const timeOfDay = getTimeOfDay(attempt.scheduledStartDate);

  const window =
    arrivalWindow === SPECIFIED_TIME
      ? `Arrival time: ${formatDate(
          attempt.scheduledStartDate,
          DATE_TIME_FORMATS.HOURS_MINUTES
        )}`
      : `Arrival window: ${timeOfDay} ${getTimeOfDayInterval(timeOfDay)}`;

  return window;
};

export const getOrderSandSubject = (attempt) => {
  const orderNumber = attempt.assignment?.assignmentNumber || "N/A";

  return `Sand Request for ${orderNumber} at ${getOneLineAddress(
    attempt.home.address
  )}`;
};

export const getOrderSandDetails = (recipients, attempt) => {
  const recipientNames = getRecipientName(recipients);

  return `${recipientNames},\n\nWe're requesting sand to be delivered on ${formatDate(
    attempt.scheduledStartDate,
    DATE_TIME_FORMATS.FORMAT_MM_DD_YY
  )} for ${getOneLineAddress(attempt.home.address)}`;
};
